import { faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

interface UnitsToggleProps {
    isMmol: boolean;
    onToggleClick: () => void;
}

export class UnitsToggle extends React.Component<UnitsToggleProps> {
    constructor(props: UnitsToggleProps) {
        super(props);
    }

    render() {
        return (
            <button id="GlucoseUnits" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); this.props.onToggleClick() }}><FontAwesomeIcon icon={faToggleOn} className="fa-fw" aria-hidden="true" />{this.props.isMmol ? "mmol/L" : "mg/dl"}</button>
        );
    }
}
